export default __webpack_public_path__ + "static/media/emergency_location.f1d7ab08.png";